export default {"src":"/_next/static/media/fixed-rent.05d1b41a.svg","height":171,"width":227};